import { useState } from 'react';
import { useQuery } from 'react-query';
import { fetchFilters } from '../../api/filters.api';
import { FilterImageCollapse } from '../atoms/Collapse';
import { FilterAccordion } from '../organisms/Sidebar/FilterAccordion';

export const FiltersCollapse = ({ show, setShow }) => {
  const [openAccordion, setOpenAccordion] = useState(false);
  const { data } = useQuery('filters', () => fetchFilters(''));

  return (
    <FilterImageCollapse
      label={'Filtres'}
      show={show}
      setShow={setShow}
      id={'filters'}
    >
      {data?.map((item, index) => {
        return (
          <FilterAccordion
            key={index}
            open={openAccordion}
            setOpen={setOpenAccordion}
            data={item}
            parentKey={'filters'}
            itemsKey={'filterValues'}
          />
        );
      })}
    </FilterImageCollapse>
  );
};
